import { render } from "./PedidosList.vue?vue&type=template&id=0dc33da2&scoped=true"
import script from "./PedidosList.vue?vue&type=script&lang=js"
export * from "./PedidosList.vue?vue&type=script&lang=js"

import "./PedidosList.vue?vue&type=style&index=0&id=0dc33da2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc33da2"]])

export default __exports__